// extracted by mini-css-extract-plugin
export var actions = "_15-0";
export var actionsContainer = "_15-6";
export var border = "_15-1";
export var childFullHeight = "_15-d";
export var collapse = "_15-2";
export var content = "_15-8";
export var contentChild = "_15-c";
export var fullscreen = "_15-a";
export var headerContainer = "_15-3";
export var headerRow = "_15-5";
export var hidePadding = "_15-9";
export var noScrollX = "_15-e";
export var noScrollY = "_15-f";
export var optOutTopPadding = "_15-b";
export var pagePadding = "_15-7";
export var profile = "_15-g";
export var profileContainer = "_15-h";
export var profileImage = "_15-i";
export var profileMain = "_15-j";
export var profileSubtitle = "_15-l";
export var profileTitle = "_15-k";
export var tabsWrapper = "_15-4";
export var title = "_15-m";